import React from 'react'
import Profile from '../ProfilePages/Profile'

const Tagged = () => {
  return (
    <div>
        <Profile />
    </div>
  )
}

export default Tagged